import { put, select } from 'redux-saga/effects'

import Lifecycle from 'common/modules/lifecycle'
import Zoid from 'common/modules/zoid'
import Internal from 'common/modules/internal'
import Wizard from 'common/modules/wizard'
import Loader from 'common/modules/loader'

import { creators } from '../actions'

import selectors from '../selectors'

export function* watchInitFrame() {
    const haveAllFrameInitialized = yield select(selectors.haveAllFrameInitialized)

    if (haveAllFrameInitialized) {
        yield put(Lifecycle.creators.picoReady())
        yield put(creators.picoReady())
    }
}

export function* watchCreateFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/CREATE_CHILD/${frame}`, payload)
}

export function* watchHideFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)

    sendHostMessage(`FRAME/HIDE_CHILD/${frame}`, payload)

    if (frame === 'pico_prompt') {
        yield put(Internal.creators.sendMessage({
            payload: {
                target: 'pico_prompt',
                ...Wizard.creators.deleteWizards(),
            },
        }))
    }
}

export function* watchShowFrame({ frame, popupId, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/SHOW_CHILD/${frame}`, payload)

    if (frame === 'pico_prompt' && popupId) {
        const popup = yield select(Loader.selectors.popupGetPopupById, popupId)

        yield put(Lifecycle.creators.popupPrompt({
            payload: {
                promptType: popup?.type,
                triggerId: popup?.id,
            },
        }))
    }
}

export function* watchToggleFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/TOGGLE_CHILD/${frame}`, payload)
}

export function* watchDestroyFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/DESTROY_CHILD/${frame}`, payload)
}
